import SignInModal from '../component/auth/signInModal';

export default function Login() {
  return <SignInModal />;
}
